import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {
  @Input() topBarTitle: string | undefined;
  loggedInUser = sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
  iseQMSApp = true;
  constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.validateApplicationTitle();
    this.removeScrollInLimsHosted()
  }

  //used to check if eQMS loaded with Helium or not, If yes then we append title to elimsBOt top nav bar's ID
  private validateApplicationTitle(): void {
    if (ConfigurationService.isLimsHosted) {
      const navBarTitleElement =
        this.elementRef.nativeElement.ownerDocument.getElementById('navBarTitle');
      if (navBarTitleElement) {
        this.renderer.setProperty(navBarTitleElement,'textContent',this.topBarTitle);
      }
      this.iseQMSApp = false;
    } else {
      this.iseQMSApp = true;
    }
  }

  removeScrollInLimsHosted(){
    if (ConfigurationService.isLimsHosted) {
      const wrapperElement = this.elementRef.nativeElement.ownerDocument.getElementById('wrapper');
      if (wrapperElement) {
        this.renderer.setStyle(wrapperElement, 'overflow-y', 'hidden');
      }
    } 
  }
}
